import React from "react";
import { Box, Typography, Button } from "@mui/material";

export default function FinnishLanguagePage() {
    return (
        <Box sx={{ padding: "2rem", background: "#f9fafb", maxWidth: "900px", margin: "auto" }}>
            <Typography variant="h4" sx={{ fontWeight: "700", color: "#09122C", mb: 2 }}>
                Learn Finnish & English – Finland Work Integration
            </Typography>

            <Typography variant="body1" sx={{ mb: 2, color: "#374151", lineHeight: 1.7 }}>
                Our Finnish and English programs support professionals relocating to Finland for work, study, or permanent settlement. We help learners master communication for healthcare, technology, manufacturing, and service industries.
            </Typography>

            <ul style={{ lineHeight: "1.8", color: "#374151" }}>
                <li>Finnish CEFR-aligned beginner to advanced tracks</li>
                <li>IELTS & TOEFL prep with certified instructors</li>
                <li>Support for Kela, residence permit, and integration programs</li>
                <li>Community-based cultural sessions</li>
            </ul>

            <Button
                variant="contained"
                href="/#"
                sx={{
                    mt: 3,
                    backgroundColor: "#065f46",
                    "&:hover": { backgroundColor: "#09122C" }
                }}
            >
                Explore Finland Language Programs
            </Button>
        </Box>
    );
}
